
const Formatter = {
    money: $.datatable.renders.number(".", ",", 2, "R$ ").display,

    percentage: $.fn.dataTable.render.number('.', ',', 2, '', '%').display,

    dateTime(date) {
        return moment(date).format('DD/MM/YYYY [às] HH:mm')
    },
};

export default Formatter;



// WEBPACK FOOTER //
// src/utils/Formatter.js